var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { postCheckFieldTemplateApi } from '@cores/apis/workspace_api/workspace';
import { RavenService } from '@cores/modules/raven-module/raven-service';
import { EditingSpaceModel } from '@/domains/editing-space/models/editing-space-model.interface';
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { SpaceType } from '@/domains/spaces/enums';
let SpaceTemplateAlertServiceImpl = class SpaceTemplateAlertServiceImpl {
    constructor(_editingSpaceModel, _ravenService, _logger) {
        this._editingSpaceModel = _editingSpaceModel;
        this._ravenService = _ravenService;
        this._logger = _logger;
        this._emitter = new Emitter();
    }
    get onStatesChange() {
        return this._emitter.event;
    }
    watch() {
        let lastSpaceTemplate = undefined;
        let lastSpaceType = SpaceType.Personal;
        return this._editingSpaceModel.onStatesChange((states) => {
            if (states.templateId !== lastSpaceTemplate
                || states.spaceType !== lastSpaceType) {
                lastSpaceTemplate = states.templateId;
                lastSpaceType = states.spaceType || lastSpaceType;
                this._emitter.fire([]);
                if (lastSpaceTemplate && lastSpaceType) {
                    this._tryCheckTemplate(lastSpaceTemplate, lastSpaceType);
                }
            }
        });
    }
    async _tryCheckTemplate(templateId, spaceType) {
        try {
            const result = await this._getCheckResult(templateId, spaceType);
            this._emitter.fire(result);
        }
        catch (e) {
            this._logger.error(e);
        }
    }
    async _getCheckResult(templateId, spaceType) {
        // @ts-ignore
        const res = await postCheckFieldTemplateApi({
            create_space_type: spaceType,
            field_template_id: templateId,
        });
        let result = [];
        if (!res.custom_field_match && res.field_defs && res.field_defs.length > 0) {
            this._ravenService.track('Check Field Template');
            result = res.field_defs;
        }
        return result;
    }
};
SpaceTemplateAlertServiceImpl = __decorate([
    injectable(),
    __param(0, inject(EditingSpaceModel)),
    __param(1, inject(RavenService)),
    __param(2, inject(Logger)),
    __metadata("design:paramtypes", [typeof (_a = typeof EditingSpaceModel !== "undefined" && EditingSpaceModel) === "function" ? _a : Object, typeof (_b = typeof RavenService !== "undefined" && RavenService) === "function" ? _b : Object, typeof (_c = typeof Logger !== "undefined" && Logger) === "function" ? _c : Object])
], SpaceTemplateAlertServiceImpl);
export { SpaceTemplateAlertServiceImpl };
